<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'devicegroup',
})
</script>
<template>
  <a-card title="RPC日志">
    <template  #extra>
        <lanseed-form-only ref="form" :data="searchVal" :rules="searchRule" :mode="false" @change="search">
        </lanseed-form-only>
    </template>
    <a-table :dataSource="dataSource" :pagination="page"
    :loading="loading" :columns="columns" @change="pageChange" >
    <template #bodyCell="{ column, record,index }">
        <template v-if="column.key=='IsSuccess'">
             <a-tag class="bg-primary radius" v-if="record.IsSuccess">成功</a-tag>
             <a-tag class="bg-red  radius" v-else>失败</a-tag>
        </template>
        <template v-if="column.key=='RpcSide'">
              {{ AutoData.FindName(datamodel,'RpcSide',record.RpcSide) }}
        </template>
    </template>
    </a-table>
  </a-card>
</template>

<script setup lang="ts" name="devicegroup">
import api from '@/utils/http/service'
import LanseedFormOnly from '@/components/lanseed/formonly.vue'
import LanseedForm from '@/components/lanseed/form.vue'
import detail from './detail.vue'
import {onMounted,defineProps,ref,watch,reactive,createVNode,defineComponent} from 'vue'
import { PlusOutlined,EditOutlined,DeleteOutlined,ContainerOutlined} from '@ant-design/icons-vue'

import { AutoData } from '@/utils/util'

  const auth:any=api.auth()
  const datamodel=ref<any>()//原始数据类型
  onMounted(()=>{
    api.rpclog.model().then(res=>{
      if(res.state==1){
        datamodel.value=AutoData.InitModel(res.data)
        columns.value=AutoData.GetTableModel(datamodel.value,['RpcSide','Method','Params','IsSuccess','Description','StartTime','EndTime'],false)
        getList()
      }
    })
  })

const searchVal:Record=ref({
  keyword:'',
})
const searchRule:Record=ref({
  keyword:{name:'关键字'}
})
const columns=ref<Array<object>>()
const page=ref<PageData>({
    current:1,
    pageSize:10,
    pageFlag:true,
    total:0,
    pageStatus:'more',
    currentKey: 'pageIndex',
    pageSizeKey: 'pageSize',
  })
  const search=(e):void=>{
    searchVal.value=e
    page.value.current=1
    getList()
  }
  const loading=ref<boolean>(false)
  const dataSource=ref<Array<any>>([])
  const getList=():void=>{
    loading.value=true

      api.rpclog.list({pageIndex:page.value.current,pageSize:page.value.pageSize,...searchVal}).then(res => {
        loading.value=false
        if(res.state==1){
            dataSource.value=res.data.data
          page.value.total=res.data.records
          page.value.current=res.data.pageIndex
        }
      })
  }
  const pageChange=(e:anly)=>{
    page.value=e
    getList()
  }

</script>
